"use client";

import { useRef, useState } from "react";
import styles from "./_video-container.module.scss";
import Video from "@/components/video";
import getOptimizedImageUrl from "@/util/getOptimizedImageUrl";

export default function HcpVideoContainer({
  sectionTitle = null,
  videoURL,
  thumbnailSrc,
  title = "",
  description,
  alt = "",
  label = null,
  caption = null,
}) {
  const videoRef = useRef(null);
  const [videoPlaying, setVideoPlaying] = useState(false);

  const slugfy = (text) => {
    return text
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  };

  return (
    <section className={`hcp-video-container ${styles.container}`}>
      <div className={`container ${styles.content}`}>
        {sectionTitle && (
          <h2 className={`h3 ${styles.section_title}`}>{sectionTitle}</h2>
        )}
        <div className={styles.video_wrapper}>
          <Video
            ref={videoRef}
            url={videoURL}
            title={title}
            poster={getOptimizedImageUrl(thumbnailSrc, 2560)}
            id={slugfy(title)}
            autoplay={true}
            onVideoPause={() => setVideoPlaying(false)}
            onVideoPlay={() => setVideoPlaying(true)}
            gtmEventCategory="Video"
            gtmEventAction="Start"
            gtmEventLabel={label? label : `${title} Play Button`}
            caption={caption}
          />

          <div className={`hcp-video-text ${styles.video_text}`}>
            <p className={styles.video_title}>{title}</p>
            <p className={styles.video_description}>{description}</p>
          </div>
        </div>
      </div>
    </section>
  );
}